<template>
  <div
    class="flex items-center justify-between border border-mid-gray rounded-lg bg-bkk-10 px-4 py-2 w-full"
  >
    <div class="text-medium">{{ name }}</div>

    <div class="flex flex-col text-right mr-4">
      <span class="font-bold">{{ size }} / {{ maxMember }}</span>
      <span class="text-small">{{ t("comp.challenge.teams.places") }}</span>
    </div>

    <button
      v-if="size < maxMember"
      class="border border-mid-gray rounded-full px-4 py-1 text-sm font-bold"
      @click="openJoinTeamModal = true"
    >
      {{ t("comp.challenge.teams.join.button.caption") }}
    </button>
    <button
      v-else
      class="border border-light-gray rounded-full px-4 py-1 text-sm font-bold bg-bkk-10 text-light-gray cursor-not-allowed"
    >
      {{ t("comp.challenge.teams.join.button.caption") }}
    </button>
  </div>
  <JoinTeamModal
    :id="id"
    :open="openJoinTeamModal"
    :name="name"
    :challenge-id="challengeId"
    @close="openJoinTeamModal = false"
  />
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
import { ref } from "vue";
import JoinTeamModal from "./JoinTeamModal.vue";

defineProps<{
  name: string;
  size: number;
  id: number;
  maxMember: number;
  challengeId: string;
}>();

const openJoinTeamModal = ref(false);

function joinTeam() {}
</script>
